import React from 'react'
import { Breadcrumbs as HdsBreadcrumbs, Link } from '@postenbring/hedwig-react'

export const Breadcrumbs = ({ crumbs }) => {

    const BreadcrumbItems = () => {
        return crumbs.map((breadcrumb, index) => (
            <li key={breadcrumb.href}>
                {index < crumbs.length - 1 ? (
                    <Link href={breadcrumb.href}>
                        {breadcrumb.title}
                    </Link>
                ) : (
                    breadcrumb.title
                )}
            </li>
        ))
    }

    return (
        <HdsBreadcrumbs>
            <BreadcrumbItems />
        </HdsBreadcrumbs>
    )
}
